import { apiFetch } from "../utils/apiFetch";
import { API_BASE_ADMIN } from "../config/vars";

export const fetchNews = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/news/admin`);
    if (!response.ok) throw new Error("Не вдалося завантажити новини");
    return response.json();
};

export const fetchActiveNetworks = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/networks/admin/active`);
    if (!response.ok) throw new Error("Не вдалося завантажити мережі");
    return response.json();
};


export const updateNews = async (id, data) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/news/admin/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const detail = errorData.detail || errorData.message || JSON.stringify(errorData);
        throw new Error(detail || "Не вдалося оновити новину");
    }
    return response.json().catch(() => ({}));
};

export const createNews = async (data) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/news/admin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error("Не вдалося додати новину");
};
